import React from "react"
import { Heading, Hero } from "react-bulma-components"
import smileTransparent from "../smile_transparent.svg"
import Socials from "./Socials"

const SecondaryPage: React.FC = ({ children }) => {
  return (
    <div>
      <header>
        <Hero color="primary" size="small">
          <Hero.Body>
            <a href="/">
              <img className="header-image" src={smileTransparent} alt="" />
              <Heading className="header-title" size={2}>
                Beatso
              </Heading>
            </a>
          </Hero.Body>
        </Hero>
      </header>

      <main>{children}</main>
      <Socials></Socials>
    </div>
  )
}

export default SecondaryPage
